import $ from 'jquery';
import LP from '../0-lp';
import UI from '../0-ui';


// =============== //
// CHOICE QUESTION //
// =============== //
LP.choiceQuestion = {
    dispatching: false,
    onLoad: function () {
        var tabname = LP.Dialog.getTabName();
        switch (tabname) {
            case 'advanced'        :
                LP.choiceQuestion.advTab.initEvents();
                break;
            case 'codes'        :
                LP.choiceQuestion.codeTab.initEvents();
                break;
        }
    },

    initNonAjaxTabs: function () {
        LP.choiceQuestion.answerTab.initEvents();
    },

    answerTab: {
        initEvents: function (root) {
            if (!root) root = $('#advTab');

            $('select[name="question[choiceType]"]', root).change(LP.choiceQuestion.answerTab.changeChoiceType);

            $('a[action="addChoiceGroup"]', root).click(function () {
                LP.dlgQuestion.addGroupHere($('#newGroup'), $(this).closest('fieldset'), LP.choiceQuestion.answerTab.initEvents);
            });
            //LP.UI.initButtonMenu({selector:$('.lp-menubar-choicegroups', root), name:'groupMenu'});
            $('a[action="editGroupname"]', root).click(function () {
                LP.dlgQuestion.editInput($('input[name="question[groupText][]"]', this.parentNode.parentNode), this);
            });
            $('a[action="deleteGroup"]', root).click(function () {
                LP.dlgQuestion.deleteGroup(this, LP.choiceQuestion.answerTab.checkOptions);
            });

            $('a[action="addOption"]', root).click(function () {
                LP.dlgQuestion.addOptionHere($('#newGroup'), $(this).closest('li'), LP.choiceQuestion.answerTab.initEvents);
            });
            //LP.UI.initButtonMenu({selector:$('.lp-menubar-choiceoptions', root), name:'optionMenu'});
            $('a[action="editInput"]', root).click(function () {
                LP.dlgQuestion.editInput($('input[name="question[texts][]"]', this.parentNode), this);
            });
            $('a[action="deleteOption"]', root).click(function () {
                LP.dlgQuestion.deleteOption(this, LP.choiceQuestion.answerTab.checkOptions);
            });

            $('a[action="toggleInputType"]', root).click(LP.dlgQuestion.toggleInputType);
            $('a[action="toggleFixPos"]', root).click(LP.dlgQuestion.toggleFixPos);

            $('a[action="toggleAddMultiple"]', root).click(LP.choiceQuestion.answerTab.toggleAddMultiple);
            $('a[action="addMultipleOptions"]', root).click(LP.choiceQuestion.answerTab.addMultipleOptions);

            $('a[action="preSelectOption"]', root).click(LP.choiceQuestion.answerTab.preSelectOption);

            $('input[name="question[group-answers]"]', root).change(LP.choiceQuestion.answerTab.checkGroupVisibility);

            $('#lp-group-answers').click(function () {
                $('#lp-choicegroup-merge').hide();
            });
            $('#lp-ungroup-answers').click(function () {
                $('#lp-choicegroup-merge').show();
            });

            $('.lp-menubar-select').change(function () {
                this.blur();
            });
            LP.choiceQuestion.answerTab.checkOptions();
            LP.choiceQuestion.answerTab.checkGroupVisibility();
        },

        addMultipleOptions: function () {
            var $this = $(this);
            var $area = $this.siblings('textarea');
            var options = $area.val();
            var $last = $this.siblings('ul').find('li').last();

            if (options != '') {
                var optionArray = options.split(/[\r\n]+/); // split by newlines (and filter empty rows)
                optionArray.forEach(function (option) {
                    if (option.trim() == '') return; // ignore empty lines

                    LP.dlgQuestion.addOptionHere($('#newGroup'), $last, function (element) {
                        var $element = $(element);
                        $element.find('input[type="text"]').val(option.trim());

                        $last = $element;
                    });
                });
                LP.choiceQuestion.answerTab.initEvents($('.lp-answer-list'));
            }

            // and now we clean and close the input again
            $area.val('');
            LP.choiceQuestion.answerTab.toggleAddMultiple.call(this);
        },

        toggleAddMultiple: function () {
            var $this = $(this);
            var $area = $this.siblings('textarea');
            var $button = $area.siblings('a[action="addMultipleOptions"]');

            if ($area.is(':visible')) {
                $area.slideUp('fast');
                $button.slideUp('fast');
            } else {
                $area.slideDown('fast');
                $button.slideDown('fast');
            }
        },

        changeChoiceType: function () {
            var val = $(this).val();
            var value = val === 'MULTICHOICE' || val === 'MULTICHOICE2' ? '1' : '0';
            var multiOption = $('#allowMultipleDefaults');
            var oldvalue = multiOption.val();
            multiOption.val(value);

            // falls schon eine standardauswahl angeklickt wurde und hier der
            // fragetyp von single <-> multichoice wechselt, muss das irgendwie aktualisiert werden
            // da wenig zeit jetzt: erstmal klick auf erstes element simulieren...(sorry)
            if (oldvalue !== value && $('.preSelectValue[value="1"]').length > 0) {
                $('img.preSelectImage').first().click();
            }

            if (val === 'MULTICHOICE' || val === 'SINGLECHOICE') {
                $('#lp-direction').show();
            } else {
                $('#lp-direction').hide();
            }
        },

        checkOptions: function () {
            if (LP.choiceQuestion.dispatching) return; else LP.choiceQuestion.dispatching = true;
            var groups = $('#choiceGroups');
            if ($('fieldset', groups).length === 0) LP.dlgQuestion.addGroup($('#newGroup'), groups, LP.choiceQuestion.answerTab.initEvents);

            groups.children().each(function (index, group) {
                if ($('li', group).length === 0) LP.dlgQuestion.addOption($('#newGroup'), $('ul', group), LP.choiceQuestion.answerTab.initEvents);
            });

            LP.dlgQuestion.setPositions('.groupnum');
            LP.choiceQuestion.dispatching = false;
        },

        preSelectOption: function () {
            var allowMultipleDefaults = $('#allowMultipleDefaults').val() === '1';
            var allowOnePerGroupDefaults = $('#allowOnePerGroupDefault').val() === '1';

            var item = $(this).parent();
            var input = $('.preSelectValue', item);
            var state = input.val();

            // Deselect other if nessecarry
            if (!allowMultipleDefaults) {
                var rootGroup = 0;
                if (allowOnePerGroupDefaults) {
                    rootGroup = item.closest('.lp-answer-list');
                }// deselect group only
                else {
                    rootGroup = $('#choiceGroups');
                }	  // deselect all

                $('.preSelectValue', rootGroup).val('0');
                $('[action="preSelectOption"]', rootGroup).removeClass('icon-check-2').removeClass('icon-check-empty').addClass('icon-check-empty');
            }

            input.val(state === '1' ? '0' : '1');
            $('[action="preSelectOption"]', item).removeClass('icon-check-2').removeClass('icon-check-empty').addClass(state == '1' ? 'icon-check-empty' : 'icon-check-2');
        },

        preSelectItem: function (item, input, value) {
            // eslint-disable-next-line no-undef
            var src = img.attr('src');
            if (value === '1') {
                src = src.replace(/status.selected.png/g, 'status.not_selected.png');
                input.val('0');
            } else {
                src = src.replace(/status.not_selected.png/g, 'status.selected.png');
                input.val('1');
            }
            // eslint-disable-next-line no-undef
            img.attr('src', src);
        },

        checkGroupVisibility: function () {
            var choiceGroups = $('#choiceGroups');
            if ($('input[name="question[group-answers]"]:checked').val() === '1') {
                $('legend.lp-answerlegend', choiceGroups).hide();
                $('legend.lp-grouplegend', choiceGroups).show();
                $('a[action="addChoiceGroup"]').show();
            } else {
                $('a[action="addChoiceGroup"]').hide();
                $('legend.lp-grouplegend', choiceGroups).hide();
                $('legend.lp-answerlegend', choiceGroups).show();
            }
        }
    },

    advTab: {
        initEvents: function (root) {
            if (!root) root = $('body');
            $('#ignoreGroupMembership').click(function () {
                LP.choiceQuestion.advTab.onIgnoreGroupMembership();
            });

            LP.choiceQuestion.advTab.onIgnoreGroupMembership();

            $('input[name="question[hasPoints]"]').click(LP.choiceQuestion.advTab.checkHasPointsField);
            LP.choiceQuestion.advTab.checkHasPointsField();

            var minAnswerSB = $('#minAnswerSB');
            var maxAnswerSB = $('#maxAnswerSB');
            var minPointsSB = $('#minPointsSB');
            var maxPointsSB = $('#maxPointsSB');

            UI.setupSpinbox(minAnswerSB, 0, 5000, minAnswerSB.val(), 1, false, 0, true, false, false);
            UI.setupSpinbox(maxAnswerSB, 0, 5000, maxAnswerSB.val(), 1, false, 0, true, false, false);

            UI.setupSpinbox(minPointsSB, -9999, 9999, minPointsSB.val(), 1, true, null, true, false, false);
            UI.setupSpinbox(maxPointsSB, -9999, 9999, maxPointsSB.val(), 1, true, null, true, false, false);

            $('a[action="editInputDefault"]', root).click(function () {
                var ref = $(this).attr('ref');
                LP.dlgQuestion.editInput($('input[name="' + ref + '"]', $(this).closest('tr')), this);
            });
            LP.dlgQuestion.initDefaultTextInputs();
        },

        onIgnoreGroupMembership: function () {
            var onePerGroupAllowed = $('#onePerGroupAllowed');
            var checked = $('#ignoreGroupMembership').is(':checked');
            if (checked) {
                onePerGroupAllowed.attr('disabled', 'disabled');
                onePerGroupAllowed.prop('checked', false);
                $('#onePerGroupText').css('color', '#888888');
            } else {
                onePerGroupAllowed.removeAttr('disabled');
                $('#onePerGroupText').css('color', '#222222');
            }
        },

        checkHasPointsField: function () {
            var checked = $('input[name="question[hasPoints]"]').is(':checked');
            var $fs = $('.lp-choicePoints-div');

            if (!checked) {
                // $fs.addClass('inactive');
                $('input', $fs).attr('disabled', 'disabled');
            } else {
                // $fs.removeClass('inactive');
                $('input', $fs).removeAttr('disabled');
            }
        }
    },

    codeTab: {
        initEvents: function (root) {
            if (!root) root = $('body');
            $('input#lp-auto-codes', root).change(LP.dlgQuestion.checkAutoCodes);
            LP.dlgQuestion.checkAutoCodes();

            $('#questionVarname', root).keyup(function () {
                $('td.varnameCol').html($('#questionVarname').attr('value'));
            });

            LP.choiceQuestion.codeTab.setNumbers();
        },

        setNumbers: function () {
            $('.codeGroupNum').each(function (index, element) {
                $(element).html(index + 1);
            });
        }
    }
};